export class Piechart {
  title: string;
  label: string[] = [];
  piechartData: number[] = [];
  piechartColors: any[] = [{ backgroundColor: [] }];
  pieChartType: string;
}
